export type LoadingMode = 'spinner' | 'progressbar';

export type LoadingItem = {
    route: string, options: {loading: boolean, title?: string, message?: string, fullBackground?: boolean, type?: LoadingMode, progressRequest?: number}}



export const loaders :LoadingItem[] = [
    {
        route: 'check',
        options: {loading: true, message: 'Load_Data', title: 'Wait', type: 'progressbar', progressRequest:30}
    },
    {
        route: 'update',
        options: {loading: true, message: 'Save_In'}
    },
    {
        route: 'delete',
        options: {loading: true, message: 'Delete_In'}
    },    
    {
        route: 'dashboard',
        options: {loading: true, message: 'Load_Data', title: 'Wait'}
    },    
    {
        route: 'page-basket-list',
        options: {loading: true, message: 'Load_Data', title: 'Wait'}
    },    
    {
        route: 'fulltextsearch',
        options: {loading: true, message: 'Load_Data', title: 'Wait'}
    },    
    {
        route: 'page-tree-search',
        options: {loading: true, message: 'Load_Data', title: 'Wait'}
    },    
    {
        route: 'page-tree-api',
        options: {loading: true, message: 'Load_Data', title: 'Wait'}
    },        
    {
        route: 'page-request-list',
        options: {loading: true, message: 'Load_Data', title: 'Wait'}
    },
    {
        route: 'page-request-api',
        options: {loading: true, message: 'Load_Data', title: 'Wait'}
    },    
    {
        route: 'execrequestsearch',
        options: {loading: true, message: 'Search_In', title: 'Wait'}
    },
    {
        route: 'fulltextbis',
        options: {loading: true, message: 'Search_In', title: 'Wait'}
    },
    {
        route: 'exectreesearch',
        options: {loading: true, message: 'Search_In', title: 'Wait'}
    },
    {
        route: 'delattachedfile',
        options: {loading: true, message: 'Delete_In', title: 'Wait'}
    },
    {
        route: 'renattachedfile',
        options: {loading: true, message: 'Ren_Act', title: 'Wait'}
    },
    {
        route: 'cnvattachedfile',
        options: {loading: true, message: 'Conv', title: 'Wait'}
    },
    {
        route: 'dwnlattachedfile',
        options: {loading: true, message: 'Dwnl_In', title: 'Wait'}
    },
    {
        route: 'updateaddtextpdf',
        options: {loading: true, message: 'Work_In', title: 'Wait'}
    },
    {
        route: 'updatethumbs',
        options: {loading: true, message: 'Work_In', title: 'Wait'}
    },
    {
        route: 'checkin',
        options: {loading: true, message: 'Work_In', title: 'Wait'}
    },
    {
        route: 'updateindex',
        options: {loading: true, message: 'Update_In', title: 'Wait'}
    },
    {
        route: 'verifycheckout',
        options: {loading: true, message: 'Work_In', title: 'Wait'}
    },
    {
        route: 'basketengineinsert',
        options: {loading: true, message: 'Update_In', title: 'Wait'}
    },
    {
        route: 'basketenginecopy',
        options: {loading: true, message: 'Send_In', title: 'Wait'}
    },
    {
        route: 'basketenginemove',
        options: {loading: true, message: 'Move_In', title: 'Wait'}
    },
    {
        route: 'updatecomment',
        options: {loading: true, message: 'Update_In', title: 'Wait'}
    },   
    {
        route: 'unlockdocuments',
        options: {loading: true, message: 'Work_In', title: 'Wait'}
    }, 
    {
        route: 'lockdocuments',
        options: {loading: true, message: 'Work_In', title: 'Wait'}
    }, 
    {
        route: 'logoutdocuments',
        options: {loading: true, message: 'DisConnect_In', title: 'Wait'}
    }, 
    {
        route: 'export',
        options: {loading: true, message: 'Batch_Send_In', title: 'Wait'}
    }, 
    {
        route: 'senddocmail',
        options: {loading: true, message: 'Send_In', title: 'Wait'}
    }, 
    {
        route: 'setversion',
        options: {loading: true, message: 'Vers_In', title: 'Wait'}
    },     
    {
        route: 'setright',
        options: {loading: true, message: 'Save_In', title: 'Wait'}
    },  
    {
        route: 'getversionfile',
        options: {loading: true, message: 'Dwnl_In', title: 'Wait'}
    },  
    {
        route: 'getversioncopy',
        options: {loading: true, message: 'Dwnl_In', title: 'Wait'}
    }, 
    {
        route: 'execstat',
        options: {loading: true, message: 'Batch_Send', title: 'Wait'}
    }, 
    {
        route: 'setgroupdata',
        options: {loading: true, message: 'Save_In', title: 'Wait'}
    }, 
    {
        route: 'deletegroup',
        options: {loading: true, message: 'Delete_In', title: 'Wait'}
    },  
    {
        route: 'setuserdata',
        options: {loading: true, message: 'Save_In', title: 'Wait'}
    }, 
    {
        route: 'setdelegate',
        options: {loading: true, message: 'Save_In', title: 'Wait'}
    }, 
    {
        route: 'getdata',
        options: {loading: true, message: 'Load_Data', title: 'Wait'}
    },  
    {
        route: 'setpass',
        options: {loading: true, message: 'Save_In', title: 'Wait'}
    }, 
    {
        route: 'updatepreference',
        options: {loading: true, message: 'Save_In', title: 'Wait'}
    }, 
    {
        route: 'updateallpreference',
        options: {loading: true, message: 'Save_In', title: 'Wait'}
    }, 
    {
        route: 'combo',
        options: {loading: true, message: 'Save_In', title: 'Wait'}
    }, 
    {
        route: 'getbatchdisp',
        options: {loading: true, message: 'Load_Data', title: 'Wait'}
    },  
    {
        route: 'changedoc',
        options: {loading: true, message: 'Update_In'}
    },
    {
        route: 'addattachedfile',
        options: {loading: true, message: 'Send_In'}
    },
    {
        route: 'testsmtp',
        options: {loading: true, message: 'Send_In'}
    },
    {
        route: 'workpdf',
        options: {loading: true, message: 'Work_In', title: 'Wait'}
    }
]
